module.exports = __webpack_public_path__ + "static/img/zerenxian.2e9f4214.png";